import { flatMap as lodashFlatMap } from 'lodash';

// NOTE: JS already has flatMap, but tests in Jest can fail because of old/missing polyfills
// NOTE: this flatMap just inverts the arguments of the Lodash one to make currying easy (like lodash/fp)
const flatMap = (fn, array) => lodashFlatMap(array, fn);

// noinspection JSUnusedGlobalSymbols
export default flatMap;
